import { ALLOWED_ORIGINS_FOR_UNTRAINED_MESSAGE } from "./constants";

export function showUnderTrainingBot(
  isBotDataTrained: boolean,
  baseOrigin: string,
) {
  if (
    !isBotDataTrained &&
    ALLOWED_ORIGINS_FOR_UNTRAINED_MESSAGE.includes(baseOrigin)
  ) {
    return true;
  }
  return false;
}
